export default __webpack_public_path__ + "static/media/create_entry_button.dbdfe07f.png";